import { RogItemStatus } from '../types';
import { LayerType } from './get-filtered-bboxex-for-layer';

export interface LayerInfo {
  key: LayerType;
  label: string;
  color: string;
  bboxColor: string;
  /** Single lowercase character that toggles this layer. */
  shortcut: string;
}

/**
 * The compliance action layers. Lives here rather than beside the control
 * center so the shortcut table can be tested without pulling in the React tree.
 */
export const ACTION_LAYER_CONFIG: LayerInfo[] = [
  {
    key: RogItemStatus.CORRECT,
    label: 'Correct',
    color: 'bg-green-500',
    bboxColor: '#1a8542ff',
    shortcut: 'c',
  },
  {
    key: RogItemStatus.MOVE,
    label: 'Move',
    color: 'bg-yellow-500',
    bboxColor: '#eab308',
    shortcut: 'm',
  },
  {
    key: RogItemStatus.OUT,
    label: 'Out',
    color: 'bg-red-500',
    bboxColor: '#da4444ff',
    shortcut: 'o',
  },
  {
    key: RogItemStatus.REMOVE,
    label: 'Remove',
    color: 'bg-purple-500',
    bboxColor: '#a855f7',
    shortcut: 'r',
  },
  {
    key: RogItemStatus.UNKNOWN,
    label: 'Unknown',
    color: 'bg-black',
    bboxColor: '#000',
    shortcut: 'u',
  },
];

export const COMPLIANCE_COLOR = {
  compliant: '#16a34a', // green
  non_compliant: '#eab308', // yellow
  out: '#ef4444', // red
  faceover: '#a855f7', // purple
  unknown: '#000', // black
};
